import React, { useState, useEffect } from 'react';
import { getFirestore, collection, getDocs, doc, updateDoc, getDoc, onSnapshot } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import appFirebase from '../Firebase/Firebase';
import Footer from '../Components/footer';
import Navbar from '../Components/NavBarV2';
import LateralIzquierda from '../images/imgLateralIzquierdaEvento.png';
import ImgConin1 from '../images/imgCoin1.png';
import ImgConin2 from '../images/imgCoin2.png';
import iconDinero from '../img/iconDinero.png';
import iconCalendar from '../img/iconCalendar.png';
import iconCell from '../img/iconCell.png';
import iconTrofeo from '../img/iconTrofeo.png';
import iconLogo from '../img/icon_logo.png';
import ProgressCircle from '../Pages/ProgressCircle';
import ProgressCircle2 from '../Pages/ProgressCircleDiseño2';

import Lateral2 from '../images/lateral2.png';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './coinpurchase.css';
import { parse } from 'date-fns';
import { es } from 'date-fns/locale';
const db = getFirestore(appFirebase);
const auth = getAuth(appFirebase);

const CoinPurchase = () => {
  const [coinPackages, setCoinPackages] = useState([]);
  const [user, setUser] = useState(null);
  const [role, setRole] = useState('');
  const [tiempoRestante, setTiempoRestante] = useState('');
  const [progress, setProgress] = useState(0);
  const [time, setTime] = useState(0);
  const [purchaseDate, setPurchaseDate] = useState(new Date());
  const [expirationDate, setExpirationDate] = useState(new Date());
  const [isOn, setIsOn] = useState(false);
  const [coins, setCoins] = useState(0);
  const [coinsComprados, setCoinsComprados] = useState(0);
  const[diasRes, setDiasRes] = useState(0);
  // Estado para el switch

  const navigate = useNavigate(); // Inicializar el hook

  const handleRedirect = () => {
    navigate('/portal-recargas'); // Redirigir a /Membresias
  };
  const handleRedirect2 = () => {
    navigate('/mapUsert')
  }
  const toggleSwitch = () => {
    setIsOn(!isOn);
  };
  const toggleSwitch2 = () => {
    setIsOn(!isOn);
  };
  const toggleSwitch3 = () => {
    setIsOn(!isOn);
  };
  const toggleSwitch4 = () => {
    setIsOn(!isOn);
  };

  useEffect(() => {
    const unsubscribeAuth = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const userDocRef = doc(db, 'usuarios', currentUser.uid);

        // Listener en tiempo real para los datos del usuario
        const unsubscribeSnapshot = onSnapshot(userDocRef, (doc) => {
          if (doc.exists()) {
            const userData = doc.data();
            setCoins(userData.coins || 0);
            setCoinsComprados(userData.coinsComprados || 0);
            if (userData.coinRenovation && userData.coinExpiration) {
              let parsedPurchaseDate, parsedExpirationDate;
              if (typeof userData.coinRenovation === 'object' && userData.coinRenovation.seconds) {
                parsedPurchaseDate = new Date(userData.coinRenovation.seconds * 1000);
                parsedExpirationDate = new Date(userData.coinExpiration.seconds * 1000);
              }
              if (!isNaN(parsedPurchaseDate) && !isNaN(parsedExpirationDate)) {
                setPurchaseDate(parsedPurchaseDate);
                setExpirationDate(parsedExpirationDate);
              } else {
                console.error('Las fechas no son válidas después de la conversión.');
              }
            }
          }
        });
        return () => unsubscribeSnapshot();
      }
    });
    return () => unsubscribeAuth();
  }, []);

  useEffect(() => {
    if (coinsComprados > 0) {
      const calculatedProgress =  (coins / coinsComprados) * (100);
      setProgress(calculatedProgress);
      const now = new Date();
      const totalDuration = expirationDate - purchaseDate;
setDiasRes(Math.floor(totalDuration / (1000 * 3600 * 24)));
const differenceInTime = expirationDate - now;  // Diferencia en milisegundos
const calculatedTime=(differenceInTime/totalDuration)*(100);
setTime(calculatedTime);
// Calculamos los días, horas y minutos restantes
const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));
const differenceInHours = Math.floor((differenceInTime % (1000 * 3600 * 24)) / (1000 * 3600));
const differenceInMinutes = Math.floor((differenceInTime % (1000 * 3600)) / (1000 * 60));
setTiempoRestante(`${differenceInDays}d, ${differenceInHours} h, ${differenceInMinutes} m`);


      /* elapsedTime = now - purchaseDate;
    
      if (totalDuration > 0) {
        const calculatedProgress = ((elapsedTime / totalDuration) * 100);
        //console.log(calculatedProgress);
        setTime(Math.min(Math.max(calculatedProgress, 0), 100));
      }*/
   
     

    } else {
      
      setProgress(100); // Si coinsComprados es 0, el progreso es mínimo
    }
  }, [coins, coinsComprados,purchaseDate, expirationDate]);


  useEffect(() => {
    fetchCoinPackages();
    const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const userDocRef = doc(db, 'usuarios', currentUser.uid);
        const docSnap = await getDoc(userDocRef);
        if (docSnap.exists()) {
          setRole(docSnap.data().role);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  const fetchCoinPackages = async () => {
    const querySnapshot = await getDocs(collection(db, 'coinPackages'));
    const packages = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));
    setCoinPackages(packages);

  };

  const handlePurchase = async (pkg) => {
    if (!user) {
      toast.error("Por favor, inicia sesión para comprar monedas.");
      return;
    }

    // Simulating purchase process
    const userDocRef = doc(db, 'usuarios', user.uid);
    const userDoc = await getDoc(userDocRef);

    if (userDoc.exists()) {
      const currentCoins = userDoc.data().coins || 0;
      await updateDoc(userDocRef, {
        coins: currentCoins + pkg.coinAmount
      });
      toast.success("Compra exitosa.");

      console.log(`Has comprado ${pkg.coinAmount} monedas.`);
    } else {
      toast.error("Error al obtener los datos del usuario.");
    }
  };

  return (
    <div>
      <Navbar />
      <ToastContainer />
      <br></br>
<br></br>
      <div class="contenedor-principal-coin">

        <img src={LateralIzquierda} alt="Descubre mas eventos" class="lateral-image-coin" />

        <div class="columna-1-coin">
          <h3>Saldo LaOfi</h3>
          {/*<h1>{`${coins} de ${coinsComprados} coins`}</h1>*/}
          <ProgressCircle2 progress={progress} secondaryProgress={time} coins={coins} coinsComprados={coinsComprados} diasRestantes={diasRes} />
          {time > 0 &&  <h4>Te quedan {tiempoRestante }<br></br> de vigencia de tus coins </h4>}
          {time < 0 &&  <h4>Recarga tus Coins </h4>}

          {/* <button className='btn-menbresias' onClick={handleRedirect}>Recarga tu Wallet</button> */}
        </div>

        <div class="columna-2-coin">
          <div class="grid-container">
            <div class="grid-item5" onClick={handleRedirect}>
              <div class="inner-grid">
                <div class="inner-item">Recarga</div>
                <div class="inner-item"></div>
                <div class="inner-item"></div>
                <div class="inner-item">
                  <img src={iconDinero} className='img-iconos' />
                </div>

                <div class="inner-item">
                  {/* <div className={`switch-container ${isOn ? 'switch-on' : ''}`} onClick={toggleSwitch}>
                    <div className="switch-toggle"></div>
                  </div> */}
                </div>
                <div class="inner-item">
                  <img src={iconLogo} className='img-logo2' />

                </div>


              </div>
            </div>

            <div class="grid-item2" onClick={handleRedirect2}>

              <div class="inner-grid">
                <div class="inner-item">Reserva</div>
                <div class="inner-item"></div>
                <div class="inner-item"></div>
                <div class="inner-item">
                  <img src={iconCalendar} className='img-iconos' />
                </div>

                <div class="inner-item">

                  {/* <div className={`switch-container ${isOn ? 'switch-on' : ''}`} onClick={toggleSwitch2}>
                    <div className="switch-toggle"></div>
                  </div> */}

                </div>
                <div class="inner-item">
                  <img src={iconLogo} className='img-logo2' />

                </div>

              </div>


            </div>
            <div class="grid-item3">


              <div class="inner-grid">
                <div class="inner-item">Invita</div>
                <div class="inner-item"></div>
                <div class="inner-item"></div>
                <div class="inner-item">
                  <img src={iconCell} className='img-iconos2' />
                </div>

                <div class="inner-item">
                  {/* <div className={`switch-container2 ${isOn ? 'switch-on2' : ''}`} onClick={toggleSwitch3}>
                    <div className="switch-toggle2"></div>
                  </div> */}
                </div>
                <div class="inner-item">
                  <img src={iconLogo} className='img-logo' />
                </div>


              </div>

            </div>
            <div class="grid-item4">

              <div class="inner-grid">
                <div class="inner-item">Gana</div>
                <div class="inner-item"></div>
                <div class="inner-item"></div>
                <div class="inner-item">
                  <img src={iconTrofeo} className='img-iconos2' />
                </div>

                <div class="inner-item">
                  {/* <div className={`switch-container2 ${isOn ? 'switch-on2' : ''}`} onClick={toggleSwitch4}>
                    <div className="switch-toggle2"></div>
                  </div> */}
                </div>
                <div class="inner-item">
                  <img src={iconLogo} className='img-logo' />

                </div>


              </div>

            </div>

          </div>

        </div>
        <img className='imagenlateral3' src={Lateral2} alt="Lateral" />
      </div>
    </div>
  );
};

export default CoinPurchase;
